import PriceDetail from './PriceDetail';

export default PriceDetail;